export const baseNationalityOptions = [
  {code: 'british', label: 'British'},
  {code: 'english', label: 'English'},
  {code: 'welsh', label: 'Welsh'},
  {code: 'scottish', label: 'Scottish'},
  {code: 'northernIrish', label: 'Northern Irish'},
  {code: 'other', label: 'Other'},
];

export const otherNationalityOptions = [
  {code: 'afghan', label: 'Afghan'},
  {code: 'albanian', label: 'Albanian'},
  {code: 'algerian', label: 'Algerian'},
  {code: 'american', label: 'American'},
  {code: 'andorran', label: 'Andorran'},
  {code: 'angolan', label: 'Angolan'},
  {code: 'anguillan', label: 'Anguillan'},
  {code: 'argentine', label: 'Argentine'},
  {code: 'armenian', label: 'Armenian'},
  {code: 'australian', label: 'Australian'},
  {code: 'austrian', label: 'Austrian'},
  {code: 'azerbaijani', label: 'Azerbaijani'},
  {code: 'bahamian', label: 'Bahamian'},
  {code: 'bahraini', label: 'Bahraini'},
  {code: 'bangladeshi', label: 'Bangladeshi'},
  {code: 'barbadian', label: 'Barbadian'},
  {code: 'belarusian', label: 'Belarusian'},
  {code: 'belgian', label: 'Belgian'},
  {code: 'belizean', label: 'Belizean'},
  {code: 'beninese', label: 'Beninese'},
  {code: 'bermudian', label: 'Bermudian'},
  {code: 'bhutanese', label: 'Bhutanese'},
  {code: 'bolivian', label: 'Bolivian'},
  {code: 'botswanan', label: 'Botswanan'},
  {code: 'brazilian', label: 'Brazilian'},
  {code: 'britishVirginIslander', label: 'British Virgin Islander'},
  {code: 'bruneian', label: 'Bruneian'},
  {code: 'bulgarian', label: 'Bulgarian'},
  {code: 'burkinan', label: 'Burkinan'},
  {code: 'burmese', label: 'Burmese'},
  {code: 'burundian', label: 'Burundian'},
  {code: 'cambodian', label: 'Cambodian'},
  {code: 'cameroonian', label: 'Cameroonian'},
  {code: 'canadian', label: 'Canadian'},
  {code: 'capeVerdean', label: 'Cape Verdean'},
  {code: 'caymanIslander', label: 'Cayman Islander'},
  {code: 'centralAfrican', label: 'Central African'},
  {code: 'chadian', label: 'Chadian'},
  {code: 'chilean', label: 'Chilean'},
  {code: 'chinese', label: 'Chinese'},
  {code: 'citizenOfAntiguaAndBarbuda', label: 'Citizen of Antigua and Barbuda'},
  {code: 'citizenOfBosniaAndHerzegovina', label: 'Citizen of Bosnia and Herzegovina'},
  {code: 'citizenOfGuinea-Bissau', label: 'Citizen of Guinea-Bissau'},
  {code: 'citizenOfKiribati', label: 'Citizen of Kiribati'},
  {code: 'citizenOfSeychelles', label: 'Citizen of Seychelles'},
  {code: 'citizenOfTheDominicanRepublic', label: 'Citizen of the Dominican Republic'},
  {code: 'citizenOfVanuatu', label: 'Citizen of Vanuatu '},
  {code: 'colombian', label: 'Colombian'},
  {code: 'comoran', label: 'Comoran'},
  {code: 'congolese(Congo)', label: 'Congolese (Congo)'},
  {code: 'congolese(Drc)', label: 'Congolese (DRC)'},
  {code: 'cookIslander', label: 'Cook Islander'},
  {code: 'costaRican', label: 'Costa Rican'},
  {code: 'croatian', label: 'Croatian'},
  {code: 'cuban', label: 'Cuban'},
  {code: 'cymraes', label: 'Cymraes'},
  {code: 'cymro', label: 'Cymro'},
  {code: 'cypriot', label: 'Cypriot'},
  {code: 'czech', label: 'Czech'},
  {code: 'danish', label: 'Danish'},
  {code: 'djiboutian', label: 'Djiboutian'},
  {code: 'dominican', label: 'Dominican'},
  {code: 'dutch', label: 'Dutch'},
  {code: 'eastTimorese', label: 'East Timorese'},
  {code: 'ecuadorean', label: 'Ecuadorean'},
  {code: 'egyptian', label: 'Egyptian'},
  {code: 'emirati', label: 'Emirati'},
  {code: 'equatorialGuinean', label: 'Equatorial Guinean'},
  {code: 'eritrean', label: 'Eritrean'},
  {code: 'estonian', label: 'Estonian'},
  {code: 'ethiopian', label: 'Ethiopian'},
  {code: 'faroese', label: 'Faroese'},
  {code: 'fijian', label: 'Fijian'},
  {code: 'filipino', label: 'Filipino'},
  {code: 'finnish', label: 'Finnish'},
  {code: 'french', label: 'French'},
  {code: 'gabonese', label: 'Gabonese'},
  {code: 'gambian', label: 'Gambian'},
  {code: 'georgian', label: 'Georgian'},
  {code: 'german', label: 'German'},
  {code: 'ghanaian', label: 'Ghanaian'},
  {code: 'gibraltarian', label: 'Gibraltarian'},
  {code: 'greek', label: 'Greek'},
  {code: 'greenlandic', label: 'Greenlandic'},
  {code: 'grenadian', label: 'Grenadian'},
  {code: 'guamanian', label: 'Guamanian'},
  {code: 'guatemalan', label: 'Guatemalan'},
  {code: 'guinean', label: 'Guinean'},
  {code: 'guyanese', label: 'Guyanese'},
  {code: 'haitian', label: 'Haitian'},
  {code: 'honduran', label: 'Honduran'},
  {code: 'hongKonger', label: 'Hong Konger'},
  {code: 'hungarian', label: 'Hungarian'},
  {code: 'icelandic', label: 'Icelandic'},
  {code: 'indian', label: 'Indian'},
  {code: 'indonesian', label: 'Indonesian'},
  {code: 'iranian', label: 'Iranian'},
  {code: 'iraqi', label: 'Iraqi'},
  {code: 'irish', label: 'Irish'},
  {code: 'israeli', label: 'Israeli'},
  {code: 'italian', label: 'Italian'},
  {code: 'ivorian', label: 'Ivorian'},
  {code: 'jamaican', label: 'Jamaican'},
  {code: 'japanese', label: 'Japanese'},
  {code: 'jordanian', label: 'Jordanian'},
  {code: 'kazakh', label: 'Kazakh'},
  {code: 'kenyan', label: 'Kenyan'},
  {code: 'kittitian', label: 'Kittitian'},
  {code: 'kosovan', label: 'Kosovan'},
  {code: 'kuwaiti', label: 'Kuwaiti'},
  {code: 'kyrgyz', label: 'Kyrgyz'},
  {code: 'lao', label: 'Lao'},
  {code: 'latvian', label: 'Latvian'},
  {code: 'lebanese', label: 'Lebanese'},
  {code: 'liberian', label: 'Liberian'},
  {code: 'libyan', label: 'Libyan'},
  {code: 'liechtensteinCitizen', label: 'Liechtenstein citizen'},
  {code: 'lithuanian', label: 'Lithuanian'},
  {code: 'luxembourger', label: 'Luxembourger'},
  {code: 'macanese', label: 'Macanese'},
  {code: 'macedonian', label: 'Macedonian'},
  {code: 'malagasy', label: 'Malagasy'},
  {code: 'malawian', label: 'Malawian'},
  {code: 'malaysian', label: 'Malaysian'},
  {code: 'maldivian', label: 'Maldivian'},
  {code: 'malian', label: 'Malian'},
  {code: 'maltese', label: 'Maltese'},
  {code: 'marshallese', label: 'Marshallese'},
  {code: 'martiniquais', label: 'Martiniquais'},
  {code: 'mauritanian', label: 'Mauritanian'},
  {code: 'mauritian', label: 'Mauritian'},
  {code: 'mexican', label: 'Mexican'},
  {code: 'micronesian', label: 'Micronesian'},
  {code: 'moldovan', label: 'Moldovan'},
  {code: 'monegasque', label: 'Monegasque'},
  {code: 'mongolian', label: 'Mongolian'},
  {code: 'montenegrin', label: 'Montenegrin'},
  {code: 'montserratian', label: 'Montserratian'},
  {code: 'moroccan', label: 'Moroccan'},
  {code: 'mosotho', label: 'Mosotho'},
  {code: 'mozambican', label: 'Mozambican'},
  {code: 'namibian', label: 'Namibian'},
  {code: 'nauruan', label: 'Nauruan'},
  {code: 'nepalese', label: 'Nepalese'},
  {code: 'newZealander', label: 'New Zealander'},
  {code: 'nicaraguan', label: 'Nicaraguan'},
  {code: 'nigerian', label: 'Nigerian'},
  {code: 'nigerien', label: 'Nigerien'},
  {code: 'niuean', label: 'Niuean'},
  {code: 'northKorean', label: 'North Korean'},
  {code: 'norwegian', label: 'Norwegian'},
  {code: 'omani', label: 'Omani'},
  {code: 'pakistani', label: 'Pakistani'},
  {code: 'palauan', label: 'Palauan'},
  {code: 'palestinian', label: 'Palestinian'},
  {code: 'panamanian', label: 'Panamanian'},
  {code: 'papuaNewGuinean', label: 'Papua New Guinean'},
  {code: 'paraguayan', label: 'Paraguayan'},
  {code: 'peruvian', label: 'Peruvian'},
  {code: 'pitcairnIslander', label: 'Pitcairn Islander'},
  {code: 'polish', label: 'Polish'},
  {code: 'portuguese', label: 'Portuguese'},
  {code: 'prydeinig', label: 'Prydeinig'},
  {code: 'puertoRican', label: 'Puerto Rican'},
  {code: 'qatari', label: 'Qatari'},
  {code: 'romanian', label: 'Romanian'},
  {code: 'russian', label: 'Russian'},
  {code: 'rwandan', label: 'Rwandan'},
  {code: 'salvadorean', label: 'Salvadorean'},
  {code: 'sammarinese', label: 'Sammarinese'},
  {code: 'samoan', label: 'Samoan'},
  {code: 'saoTomean', label: 'Sao Tomean'},
  {code: 'saudiArabian', label: 'Saudi Arabian'},
  {code: 'senegalese', label: 'Senegalese'},
  {code: 'serbian', label: 'Serbian'},
  {code: 'sierraLeonean', label: 'Sierra Leonean'},
  {code: 'singaporean', label: 'Singaporean'},
  {code: 'slovak', label: 'Slovak'},
  {code: 'slovenian', label: 'Slovenian'},
  {code: 'solomonIslander', label: 'Solomon Islander'},
  {code: 'somali', label: 'Somali'},
  {code: 'southAfrican', label: 'South African'},
  {code: 'southKorean', label: 'South Korean'},
  {code: 'southSudanese', label: 'South Sudanese'},
  {code: 'spanish', label: 'Spanish'},
  {code: 'sriLankan', label: 'Sri Lankan'},
  {code: 'stHelenian', label: 'St Helenian'},
  {code: 'stLucian', label: 'St Lucian'},
  {code: 'stateless', label: 'Stateless'},
  {code: 'sudanese', label: 'Sudanese'},
  {code: 'surinamese', label: 'Surinamese'},
  {code: 'swazi', label: 'Swazi'},
  {code: 'swedish', label: 'Swedish'},
  {code: 'swiss', label: 'Swiss'},
  {code: 'syrian', label: 'Syrian'},
  {code: 'taiwanese', label: 'Taiwanese'},
  {code: 'tajik', label: 'Tajik'},
  {code: 'tanzanian', label: 'Tanzanian'},
  {code: 'thai', label: 'Thai'},
  {code: 'togolese', label: 'Togolese'},
  {code: 'tongan', label: 'Tongan'},
  {code: 'trincodeadian', label: 'Trincodeadian'},
  {code: 'tristanian', label: 'Tristanian'},
  {code: 'tunisian', label: 'Tunisian'},
  {code: 'turkish', label: 'Turkish'},
  {code: 'turkmen', label: 'Turkmen'},
  {code: 'turksAndCaicosIslander', label: 'Turks and Caicos Islander'},
  {code: 'tuvaluan', label: 'Tuvaluan'},
  {code: 'ugandan', label: 'Ugandan'},
  {code: 'ukrainian', label: 'Ukrainian'},
  {code: 'uruguayan', label: 'Uruguayan'},
  {code: 'uzbek', label: 'Uzbek'},
  {code: 'vaticanCitizen', label: 'Vatican citizen'},
  {code: 'venezuelan', label: 'Venezuelan'},
  {code: 'vietnamese', label: 'Vietnamese'},
  {code: 'vincentian', label: 'Vincentian'},
  {code: 'wallisian', label: 'Wallisian'},
  {code: 'yemeni', label: 'Yemeni'},
  {code: 'zambian', label: 'Zambian'},
  {code: 'zimbabwean', label: 'Zimbabwean'},
];
